var map = {
	"./ambulance.png": 1252,
	"./bed.png": 1253,
	"./bicycle.png": 1254,
	"./boy.png": 1255,
	"./bulldozer.png": 1256,
	"./bus.png": 1257,
	"./car.png": 1258,
	"./cement-mixer.png": 1259,
	"./crane.png": 1260,
	"./excavator.png": 1261,
	"./female.png": 1262,
	"./forklift.png": 1263,
	"./galley-cart.png": 1264,
	"./girl.png": 1265,
	"./helmet.png": 1266,
	"./infant.png": 1267,
	"./lorry.png": 1268,
	"./male.png": 1269,
	"./mini-bus.png": 1270,
	"./motorcycle.png": 1271,
	"./pmd.png": 1272,
	"./police-car.png": 1273,
	"./prime-mover.png": 1274,
	"./scooter.png": 1275,
	"./seatbelt.png": 1276,
	"./ship.png": 1277,
	"./storage-bin.png": 1278,
	"./tanker.png": 1279,
	"./tractor.png": 1280,
	"./trailer.png": 1281,
	"./tram.png": 1282,
	"./van.png": 1283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1251;